import { Check } from "lucide-react";
import { LessonStatus } from "@/components/course/tree/types";
import { treeProgressIconClass } from "@/components/course/tree/treeStyles";
import { cn } from "@/lib/utils";

interface StatusIconProps {
  status: LessonStatus;
  className?: string;
}

export const StatusIcon = ({ status, className }: StatusIconProps) => {
  const box = cn(
    "inline-flex items-center justify-center",
    treeProgressIconClass,
    className
  );

  if (status === LessonStatus.Completed) {
    return (
      <span className={box}>
        <Check className="size-3.5 text-success" strokeWidth={2.5} />
      </span>
    );
  }

  if (status === LessonStatus.InProgress) {
    return (
      <span
        className={cn(box, "rounded-full border-2 border-warning")}
        aria-hidden
      />
    );
  }

  // not_started
  return (
    <span
      className={cn(box, "rounded-full border-2 border-border")}
      aria-hidden
    />
  );
};
